import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 0 40px;

  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.85rem;
    color: ${(props) => props.theme.$gray600};
    margin-bottom: 8px;
    text-decoration: none;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.$primary_green};
      text-decoration: none;
    }

    i {
      font-size: 17px;
    }
  }

  .saved-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;

    h4 {
      margin: 0;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    .saved-sub {
      margin: 4px 0 0;
      font-size: 0.9rem;
      color: ${(props) => props.theme.$gray600};
    }
  }

  .saved-batch {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 6px 0 0;
    font-size: 0.82rem;
    font-weight: 500;
    color: ${(props) => props.theme.$dark_green};

    i {
      font-size: 16px;
    }
  }

  .saved-search-input {
    max-width: 380px;
    margin-top: 16px;
    position: relative;

    i {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
      color: ${(props) => props.theme.$gray500};
      pointer-events: none;
    }

    input.form-control {
      padding-left: 36px;
    }
  }

  .batch-filters {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-top: 12px;

    button {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      max-width: 280px;
      border: 1px solid ${(props) => props.theme.$gray300};
      background: #fff;
      border-radius: 999px;
      padding: 4px 12px;
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray700};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      i {
        font-size: 15px;
      }

      &.active {
        border-color: ${(props) => props.theme.$primary_green};
        background: ${(props) => props.theme.$bg_green};
        color: ${(props) => props.theme.$dark_green};
        font-weight: 500;
      }
    }
  }

  .saved-group + .saved-group {
    margin-top: 26px;
  }

  .group-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 6px 16px;
    flex-wrap: wrap;
    margin-top: 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${(props) => props.theme.$gray300};

    .group-name {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};

      i {
        font-size: 19px;
        color: ${(props) => props.theme.$primary_green};
      }

      span {
        font-weight: 400;
        font-size: 0.8rem;
        color: ${(props) => props.theme.$gray500};
      }
    }

    .group-total {
      margin: 0;
      font-size: 0.86rem;
      color: ${(props) => props.theme.$gray700};

      strong {
        color: ${(props) => props.theme.$gray900};
      }

      span {
        color: ${(props) => props.theme.$gray500};
      }
    }
  }

  .saved-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    margin-top: 18px;

    @media only screen and (max-width: 1200px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: 768px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .saved-card {
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
    padding: 18px;
    display: flex;
    flex-direction: column;
    transition: border-color 0.15s, box-shadow 0.15s;

    &:hover {
      border-color: ${(props) => props.theme.$primary_green};
      box-shadow: 0 4px 18px rgba(0, 159, 121, 0.12);
    }

    .saved-name {
      margin: 0;
      font-size: 0.98rem;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .saved-query {
      margin: 2px 0 0;
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray500};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .saved-median-label {
      margin: 14px 0 0;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$gray600};
    }

    .saved-median {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: ${(props) => props.theme.$dark_green};
    }

    .saved-total {
      margin: 2px 0 0;
      font-size: 0.8rem;
      color: ${(props) => props.theme.$gray600};
    }

    .saved-badges {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      margin-top: 12px;

      .badge {
        font-weight: 500;
        font-size: 0.72rem;
        background: ${(props) => props.theme.$gray100};
        border: 1px solid ${(props) => props.theme.$gray300};
        color: ${(props) => props.theme.$gray700};
      }
    }

    .saved-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 14px;
      padding-top: 12px;
      border-top: 1px solid ${(props) => props.theme.$gray200};
      font-size: 0.78rem;
      color: ${(props) => props.theme.$gray500};

      .saved-actions {
        display: inline-flex;
        align-items: center;
        gap: 4px;

        a,
        button {
          border: 0;
          background: transparent;
          display: inline-flex;
          align-items: center;
          padding: 4px;
          color: ${(props) => props.theme.$gray500};

          &:hover {
            color: ${(props) => props.theme.$primary_green};
          }

          &.danger:hover {
            color: ${(props) => props.theme.$danger};
          }

          i {
            font-size: 18px;
          }
        }
      }
    }
  }

  .frozen-note {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 10px;
    background: ${(props) => props.theme.$primary_light};
    border: 1px solid ${(props) => props.theme.$primary_medium};
    font-size: 0.85rem;
    color: ${(props) => props.theme.$gray800};

    i {
      font-size: 18px;
      color: ${(props) => props.theme.$primary};
      flex-shrink: 0;
      margin-top: 1px;
    }
  }

  .detail-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-top: 16px;

    @media only screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media only screen and (max-width: 576px) {
      grid-template-columns: 1fr;
    }

    .stat-tile {
      background: #fff;
      border: 1px solid ${(props) => props.theme.$gray300};
      border-radius: 10px;
      box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
      padding: 16px;

      .stat-label {
        margin: 0;
        font-size: 0.78rem;
        color: ${(props) => props.theme.$gray600};
      }

      .stat-value {
        margin: 4px 0 0;
        font-size: 1.45rem;
        font-weight: 700;
        color: ${(props) => props.theme.$gray900};
        line-height: 1.15;
      }

      &.accent {
        border-color: ${(props) => props.theme.$primary_green};
        background: linear-gradient(135deg, ${(props) => props.theme.$bg_green}, #ffffff 70%);

        .stat-label {
          color: ${(props) => props.theme.$dark_green};
          font-weight: 700;
        }

        .stat-value {
          color: ${(props) => props.theme.$dark_green};
        }
      }
    }
  }

  .detail-table-card {
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(33, 53, 74, 0.06);
    margin-top: 14px;

    .detail-table-head {
      padding: 16px 18px;
      border-bottom: 1px solid ${(props) => props.theme.$gray200};

      p {
        margin: 0;
        font-size: 0.95rem;
        font-weight: 700;
        color: ${(props) => props.theme.$gray900};
      }
    }
  }

  .detail-notes {
    margin-top: 14px;
    background: #fff;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    padding: 16px 18px;
    font-size: 0.88rem;
    color: ${(props) => props.theme.$gray800};

    strong {
      display: block;
      margin-bottom: 4px;
      color: ${(props) => props.theme.$gray900};
    }
  }

  .loading-wrap,
  .empty-saved {
    margin-top: 48px;
    text-align: center;
    color: ${(props) => props.theme.$gray600};

    .empty-icon {
      width: 72px;
      height: 72px;
      border-radius: 18px;
      margin: 0 auto 16px;
      background: ${(props) => props.theme.$bg_green};
      border: 1px solid ${(props) => props.theme.$secondary_green_light};
      color: ${(props) => props.theme.$primary_green};
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 34px;
      }
    }

    h5 {
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    p {
      max-width: 480px;
      margin: 6px auto 16px;
      font-size: 0.9rem;
    }
  }
`;
